import React, { useEffect, useState } from "react";
import "../profile_styles/ProfileScreenStyle.css";
import { Row, Col } from "react-bootstrap";
import editButton from "./../../../assets/images/editButton.svg";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../store/store";
import { useNavigate } from "react-router-dom";
import { LocalStorage } from "../../../utils/Utils";
import Logger from "../../../utils/Logger";
import arrow from "../assets/certificateArrow.svg";
import { useApi } from "../../../service/ApiContext";
import { setPrograms } from "../../liveSessions/data/reducer/ProgramDetailReducer";
import { useAlert } from "../../../components/AlertContextComponent";
import Loader from "./../../../utils/Utils";
import { ProfileRequest } from "../data/request/ProfileRequest";
import { ProfileSaveResponse } from "../data/response/ProfileResponse";
import ProfileClient from "../data/api/LoginClient";
import { updateProfile } from "../../dashboard/data/redux/LoginReducer";

interface ProfileDisplayProps {
  onEdit: () => void;
  // onSave: () => void;
}

const ProfileDisplay: React.FC<ProfileDisplayProps> = ({ onEdit }) => {
  const userData = useSelector((state: RootState) => state.profile.profileKeys);
  const api = useApi();
  const dispatch = useDispatch();
  const { showAlert } = useAlert();

  const [listProgramData, setListProgramData] = useState<any>();

  // ---- Contact Email state ----
  const [showEmailFields, setShowEmailFields] = useState(false);
  const [contactEmail1, setContactEmail1] = useState("");
  const [contactEmail2, setContactEmail2] = useState("");

  const getProgram = async () => {
    api.setAuthToken(LocalStorage.getLocalData("access_token"));

    try {
      const response = await api.get<any>(
        "/list_program?program_category=Industry",
      );

      setListProgramData(response.data.programs || []);
    } catch (error) {
      Logger.info("error response", error);
      setListProgramData([]);
    }
  };

  Logger.info("userData", userData);
  const hasValue = (value: any) =>
    value !== null && value !== undefined && String(value).trim() !== "";
  const navigate = useNavigate();
  const userType = LocalStorage.getLocalData("userType");

  useEffect(() => {
    getProgram();
  }, []);

  // Pre-fill emails when userData changes
  useEffect(() => {
    if (userData?.contact_email) {
      const emails = String(userData.contact_email)
        .split(",")
        .map((e: string) => e.trim());
      setContactEmail1(emails[0] || "");
      setContactEmail2(emails[1] || "");
    }
  }, [userData?.contact_email]);

  const programNames =
    listProgramData?.map((program: any) => program.program_title).join(", ") ||
    "";
  const fields = [
    {
      label: "Student Roll No:",
      value: userData.roll_number,
    },
    {
      label: "Admission Year:",
      value: userData.admission_year,
    },
    {
      label:
        userType === "CANDIDATE"
          ? hasValue(userData.course)
            ? "Course:"
            : "Programs:"
          : "Grade:",
      value:
        userType === "CANDIDATE"
          ? hasValue(userData.course)
            ? userData.course
            : programNames
          : hasValue(userData.grade)
            ? userData.grade
            : programNames,
    },
    {
      label: "Qualification:",
      value: userData.education,
    },
    {
      label: "Institute:",
      value: userData.institute_name,
    },
    {
      label:
        userData.institute_id === "c979bfe5-a86f-4583-b3c5-c782e44cd2fd"
          ? "Parent Contact Emails:"
          : "Contact Email:",
      value: userData.contact_email,
    },
  ].filter((field) => hasValue(field.value));

  // ---- Save Parent Contact Email handler ----
  const handleSaveContactEmail = async () => {
    const combinedEmail = [contactEmail1, contactEmail2]
      .filter((e) => e && e.trim() !== "")
      .join(", ");

    if (!combinedEmail) {
      showAlert({
        show: true,
        title: "Error",
        message: "Please enter at least one parent contact email.",
        button1Text: "OK",
        alertType: "error",
        onlyNeedOneButton: true,
      });
      return;
    }

    Loader.showLoading("Loading...");
    api.setAuthToken(LocalStorage.getLocalData("access_token"));

    const params: ProfileRequest = {
      contact_email: combinedEmail,
    };

    try {
      const response = await api.post<ProfileSaveResponse>(
        ProfileClient.profileUrl,
        params,
      );
      dispatch(updateProfile({ ...userData, contact_email: combinedEmail }));
      showAlert({
        show: true,
        title: "Success",
        message: "Parent Contact Email saved successfully.",
        button1Text: "OK",
        alertType: "success",
        onlyNeedOneButton: true,
        btn1onPressed: () => {},
      });
      setShowEmailFields(false);
    } catch (error) {
      showAlert({
        show: true,
        title: "Error",
        message: "Failed to save profile data. Please try again.",
        button1Text: "OK",
        alertType: "error",
        onlyNeedOneButton: true,
        btn1onPressed: () => {},
      });
    } finally {
      Loader.dismissLoading();
    }
  };
  const contactEmailCount = userData?.contact_email
    ? String(userData.contact_email)
        .split(",")
        .map((e: string) => e.trim())
        .filter((e: string) => e !== "").length
    : 0;
  return (
    <div className="v2-profile-container">
      <div className="v2-profile-header">
        <p className="v2-profile-title">My Account</p>
      </div>

      {/* TOP CARD */}
      <div style={{ padding: "20px", height: "88vh", overflowY: "auto" }}>
        <div className="v2-profile-top-card">
          <div className="v2-profile-user-section">
            <div className="v2-profile-avatar">
              {`${userData.first_name?.[0] || ""}${
                userData.last_name?.[0] || ""
              }`}
            </div>

            <div className="v2-profile-user-details">
              <p className="v2-profile-name">
                {userData.first_name} {userData.last_name}
              </p>

              <p className="v2-profile-email">{userData.email_address}</p>
            </div>
          </div>

          <button
            className="v2-profile-certificate-btn"
            onClick={() => {
              navigate("/dashboard/certificates");
            }}
          >
            View My Certificates <img src={arrow} alt="" />
          </button>
        </div>

        {/* ACADEMIC CARD */}
        <div className="v2-profile-info-card">
          <div className="v2-profile-section-header">
            <p className="v2-profile-section-title">Academic Information</p>
            {userData.partner_institute === false && (
              <img
                src={editButton}
                alt="edit"
                className="v2-profile-edit-icon"
                onClick={onEdit}
              />
            )}
          </div>

          <div className="v2-profile-grid">
            {fields.map((field) => (
              <div key={field.label} className="v2-profile-field">
                <span className="v2-profile-field-label">{field.label}</span>

                <span className="v2-profile-field-value">{field.value}</span>
              </div>
            ))}
          </div>

          {/* ================= PARENT CONTACT EMAIL SECTION ================= */}
          {userData.institute_id === "c979bfe5-a86f-4583-b3c5-c782e44cd2fd" && (
            <div className="v2-contact-email-section">
              {!showEmailFields ? (
                <button
                  className="v2-contact-email-add-btn"
                  onClick={() => setShowEmailFields(true)}
                >
                  {contactEmailCount === 2
                    ? "Edit Parent Contact Emails"
                    : "+ Add Parent Contact Emails"}
                </button>
              ) : (
                <div className="v2-contact-email-form">
                  <p className="v2-contact-email-title">
                    Parent Contact Emails
                  </p>

                  <div className="v2-profile-grid">
                    <div className="v2-profile-field">
                      <span className="v2-profile-field-label">
                        Parent Contact Email 1:
                      </span>
                      <input
                        type="email"
                        className="v2-profile-field-input"
                        placeholder="Enter email"
                        value={contactEmail1}
                        onChange={(e) => setContactEmail1(e.target.value)}
                      />
                    </div>

                    <div className="v2-profile-field">
                      <span className="v2-profile-field-label">
                        Parent Contact Email 2:
                      </span>
                      <input
                        type="email"
                        className="v2-profile-field-input"
                        placeholder="Enter email"
                        value={contactEmail2}
                        onChange={(e) => setContactEmail2(e.target.value)}
                      />
                    </div>
                  </div>

                  <div className="v2-contact-email-actions">
                    <button
                      className="v2-profile-cancel-btn-dark"
                      onClick={() => setShowEmailFields(false)}
                    >
                      Cancel
                    </button>
                    <button
                      className="v2-profile-save-btn"
                      onClick={handleSaveContactEmail}
                    >
                      Save Parent Contact Email
                    </button>
                  </div>
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ProfileDisplay;
